const PAXSHOTEL_FETCH = (state, PaxsHotel) => {
  state.PaxsHotel = PaxsHotel
}

export default {
  PAXSHOTEL_FETCH
}
